export class LoadTimeSheets {
    public static readonly type = '[JobsPlacements] Load timesheets request';

    constructor(public placementId: number) { }
}
